import type { AssessmentRecord } from "../types"

export type FeedbackPhase = "pending" | "failed" | "ready"

export const feedbackPhaseOf = (record: AssessmentRecord): FeedbackPhase => {
  if (record.kind === "question") {
    if (record.attempt.status === "marking") return "pending"
    if (record.attempt.status === "failed") return "failed"
    return "ready"
  }
  if (record.session.assessmentStatus === "failed") return "failed"
  if (
    record.session.status === "submitted" &&
    (record.session.assessmentStatus === "queued" ||
      record.session.assessmentStatus === "processing")
  ) {
    return "pending"
  }
  return "ready"
}

export const feedbackErrorOf = (record: AssessmentRecord): string | null => {
  if (record.kind === "question") return record.attempt.assessmentError || null
  return record.session.assessmentError || null
}
